import React from 'react';
import css from './EditListingDetailsForm.module.css';
import { FieldSelect } from '../../../../components';
import { divisionOptions } from '../../../../config/configExtras';
import { getConferences } from '../../../../util/editListingHelpers';
const DivisionConferenceSchoolFields = ({ form, values, intl }) => {
  return (
    <div className={css.customFields}>
      <FieldSelect
        className={css.customField}
        name="division"
        id="division"
        label={intl.formatMessage({ id: 'EditListingDetailsForm.divisionLabel' })}
        onChange={value => form.change('division', value)}
      >
        <option disabled value="">
          {intl.formatMessage({ id: 'EditListingDetailsForm.divisionOption' })}
        </option>
        {divisionOptions.map((o, index) => (
          <option key={index} value={o.key}>
            {o.value}
          </option>
        ))}
      </FieldSelect>

      {values?.division && (
        <FieldSelect
          className={css.customField}
          name="conference"
          id="conference"
          label={intl.formatMessage({ id: 'EditListingDetailsForm.conferenceLabel' })}
          onChange={value => form.change('conference', value)}
        >
          <option disabled value="">
            {intl.formatMessage({ id: 'EditListingDetailsForm.conferenceOption' })}
          </option>
          {getConferences(values.division).map((conference, index) => (
            <option key={index} value={conference}>
              {conference}
            </option>
          ))}
        </FieldSelect>
      )}
    </div>
  );
};

export default DivisionConferenceSchoolFields;
